import { createSlice } from "@reduxjs/toolkit";
const savedUser = JSON.parse(localStorage.getItem("dari-token"));
const initialState = {
  token: null,
  user: null,
  tempUser: null, // saved temrorarily in redux
  forgotPassword: null, // {token, number, password} saved tempraroly in redux
};
if (savedUser) {
  initialState.token = savedUser.token;
  initialState.user = savedUser.user;
}

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setCredentials: (state, { payload: { user, token } }) => {
      state.user = user;
      state.token = token;
    },
    setTempUser: (state, { payload: { user } }) => {
      state.tempUser = user;
    },
    clearCredentials: (state) => {
      state.user = null;
      state.token = null;
    },
    setForgotPassword: (state, { payload }) => {
      state.forgotPassword = payload;
    },
  },
  extraReducers: (builder) => {},
});

export const {
  setCredentials,
  setTempUser,
  clearCredentials,
  setForgotPassword,
} = authSlice.actions;

export default authSlice.reducer;

export const selectCurrentUser = (state) => state.auth.user;
export const selectTempUser = (state) => state.auth.tempUser;
export const selectForgotPassword = (state) => state.auth.forgotPassword;
